import {
  ADD_EVENT_TO_CURRENT_CALENDAR,
  ASSOCIATE_SAVING_ACCOUNT,
  CREATE_RETIREMENT_INCOME,
  DELETE_RETIREMENT_INCOME,
  DISABLE_RETIREMENT_INCOME,
  DISSOCIATE_SAVING_ACCOUNT,
  ENABLE_RETIREMENT_INCOME,
  FETCHING_EVENT_DETAIL,
  RESET_RETIREMENT_INCOME_DATA,
  RESTORE_SOCIAL_SECURITY_INCOME,
  SET_AVAILABLE_HOURS,
  SET_CLEAN_EVENTS,
  SET_EDUCATOR_EVENTS,
  SET_EVENT_AS_CANCEL,
  SET_EVENT_AS_CONFIRMED,
  SET_EVENT_DETAILS,
  SET_FAQ,
  SET_IDEAL_RETIREMENT_INCOME,
  SET_LIFE_TIME_INCOME,
  SET_LOADING_PARTICIPANT_EVENTS,
  SET_PARTICIPANTS_EVENTS,
  SET_PARTICIPANT_SAVING_ACCOUNTS,
  SET_RETIREMENT_INCOME_DATA,
  SET_UPCOMING_EVENTS,
  SET_UTC_DETAILS,
  SET_WORKING_HOURS,
  TOGGLE_EVENT_MODAL,
  TOGGLE_ONE_ON_ONE_MODAL,
  UPDATE_RETIREMENT_INCOME,
  UPDATE_SOCIAL_SECURITY_INCOME,
} from "../actions/actionsTypes";

export const EVENT_DETAIL_DEFAULT_DATA = {
  confirmedGuest: 0,
  eventId: null,
  title: "",
  start: null,
  end: null,
  startHour: "",
  endHour: "",
  utc: { utcId: 0 },
  eventType: { eventTypeId: 1 },
  reminderScheduleId: 0,
  description: "",
  notes: "",
  location: "",
  guest: {
    guestList: [],
    profileId: "",
  },
};

const initialState = {
  isLoaded: false,
  savingAccountData: {
    totalBalance: 0,
    retirementAccounts: [],
  },
  retirementIncomeData: {
    incomeTypes: [],
    totalIncome: 0,
    retirementIncomes: [],
    retirementAccounts: [],
    totalSaving: 0,
  },
  idealRetirementAmount: 0,
  lifetimeIncome: [0, 0, 0],
  events: [],
  educatorEvents: [],
  educatorParseEvents: [],
  isFetchingEventDetail: false,
  eventDetails: {
    ...EVENT_DETAIL_DEFAULT_DATA,
  },
  upcomingEvents: [],
  workingHours: {
    enabled: true,
    workingHours: [],
    daysAvailable: {},
    availableHours: [],
  },
  faq: [],
  eventModalData: {
    openEventModal: false,
    eventId: null,
  },
  oneOnOneModalData: {
    open: false,
    eventId: null,
  },
};

const parseNumber = (num) => Number(Number(num || 0).toFixed(2));

export const bucketReducer = (state = initialState, action) => {
  if (action.type === SET_PARTICIPANT_SAVING_ACCOUNTS) {
    return {
      ...state,
      savingAccountData: action.payload,
    };
  }
  if (action.type === ASSOCIATE_SAVING_ACCOUNT) {
    const { retirementAccounts } = state.savingAccountData;
    let { totalBalance } = state.savingAccountData;

    for (let idx = 0; idx < retirementAccounts.length; idx += 1) {
      const acc = retirementAccounts[idx];
      if (acc.accountGuid === action.payload) {
        acc.associated = true;
        totalBalance = parseNumber(totalBalance) + parseNumber(acc.balance);
        break;
      }
    }

    return {
      ...state,
      savingAccountData: {
        retirementAccounts,
        totalBalance,
      },
    };
  }

  if (action.type === DISSOCIATE_SAVING_ACCOUNT) {
    const { retirementAccounts } = state.savingAccountData;
    let { totalBalance } = state.savingAccountData;

    for (let idx = 0; idx < retirementAccounts.length; idx += 1) {
      const acc = retirementAccounts[idx];
      if (acc.accountGuid === action.payload) {
        acc.associated = false;
        totalBalance = parseNumber(totalBalance) - parseNumber(acc.balance);
        break;
      }
    }

    return {
      ...state,
      savingAccountData: {
        retirementAccounts,
        totalBalance,
      },
    };
  }

  if (action.type === SET_RETIREMENT_INCOME_DATA) {
    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        ...action.payload,
      },
    };
  }

  if (action.type === RESET_RETIREMENT_INCOME_DATA) {
    return {
      ...state,
      retirementIncomeData: {
        ...initialState.retirementIncomeData,
      },
    };
  }

  if (action.type === CREATE_RETIREMENT_INCOME) {
    const { retirementIncomes, totalIncome } = state.retirementIncomeData;
    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes: [...retirementIncomes, action.payload],
        totalIncome:
          parseNumber(totalIncome) +
          parseNumber(action.payload.enabled ? action.payload.amount : 0),
      },
    };
  }

  if (action.type === UPDATE_RETIREMENT_INCOME) {
    const { retirementIncomes } = state.retirementIncomeData;
    let { totalIncome } = state.retirementIncomeData;

    for (let idx = 0; idx < retirementIncomes.length; idx += 1) {
      const income = retirementIncomes[idx];
      if (income.retirementIncomeId === action.payload.retirementIncomeId) {
        if (income.enabled)
          totalIncome =
            parseNumber(totalIncome) -
            parseNumber(income.amount) +
            parseNumber(action.payload.amount);
        const { enabled, ...dataToUpdate } = action.payload;
        retirementIncomes[idx] = { enabled, ...income, ...dataToUpdate };
        break;
      }
    }

    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes,
        totalIncome,
      },
    };
  }

  if (action.type === DELETE_RETIREMENT_INCOME) {
    let { totalIncome } = state.retirementIncomeData;

    const retirementIncomes =
      state.retirementIncomeData.retirementIncomes.filter((income) => {
        const shouldBeExclude =
          income.retirementIncomeId === action.payload.retirementIncomeId;
        if (shouldBeExclude && income.enabled)
          totalIncome = parseNumber(totalIncome) - parseNumber(income.amount);
        return !shouldBeExclude;
      });

    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes,
        totalIncome,
      },
    };
  }

  if (action.type === ENABLE_RETIREMENT_INCOME) {
    const { retirementIncomes } = state.retirementIncomeData;
    let { totalIncome } = state.retirementIncomeData;

    for (let idx = 0; idx < retirementIncomes.length; idx += 1) {
      const income = retirementIncomes[idx];
      if (income.retirementIncomeId === action.payload.retirementIncomeId) {
        totalIncome = parseNumber(totalIncome) + parseNumber(income.amount);
        income.enabled = true;
        break;
      }
    }

    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes,
        totalIncome,
      },
    };
  }

  if (action.type === DISABLE_RETIREMENT_INCOME) {
    const { retirementIncomes } = state.retirementIncomeData;
    let { totalIncome } = state.retirementIncomeData;

    for (let idx = 0; idx < retirementIncomes.length; idx += 1) {
      const income = retirementIncomes[idx];
      if (income.retirementIncomeId === action.payload.retirementIncomeId) {
        totalIncome = parseNumber(totalIncome) - parseNumber(income.amount);
        income.enabled = false;
        break;
      }
    }

    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes,
        totalIncome,
      },
    };
  }

  if (action.type === SET_IDEAL_RETIREMENT_INCOME) {
    return {
      ...state,
      idealRetirementAmount: action.payload,
    };
  }

  if (action.type === RESTORE_SOCIAL_SECURITY_INCOME) {
    const { retirementIncomes } = state.retirementIncomeData;
    const mappedIncomes = action.payload.retirementIncomes.reduce(
      (acc, income) => {
        if (income.default) acc[income.retirementIncomeId] = income;

        return acc;
      },
      {}
    );
    const { totalIncome } = action.payload;

    for (let idx = 0; idx < retirementIncomes.length; idx += 1) {
      const income = retirementIncomes[idx];
      if (income.default) {
        income.amount = mappedIncomes[income.retirementIncomeId]?.amount;
      }
    }

    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes,
        totalIncome,
      },
    };
  }

  if (action.type === UPDATE_SOCIAL_SECURITY_INCOME) {
    const { retirementIncomes } = state.retirementIncomeData;
    let { totalIncome } = state.retirementIncomeData;

    for (let idx = 0; idx < retirementIncomes.length; idx += 1) {
      const income = retirementIncomes[idx];
      if (income.retirementIncomeId === action.payload.retirementIncomeId) {
        if (income.enabled)
          totalIncome =
            parseNumber(totalIncome) -
            parseNumber(income.amount) +
            parseNumber(action.payload.amount);
        const { amount } = action.payload;
        retirementIncomes[idx] = { ...income, amount };
        break;
      }
    }

    return {
      ...state,
      retirementIncomeData: {
        ...state.retirementIncomeData,
        retirementIncomes,
        totalIncome,
      },
    };
  }

  if (action.type === SET_LIFE_TIME_INCOME) {
    const { median, percentile10, percentile75 } = action.payload;
    return {
      ...state,
      lifetimeIncome: [percentile10, median, percentile75],
    };
  }

  if (action.type === SET_LOADING_PARTICIPANT_EVENTS) {
    const { isLoaded } = action.payload;

    return {
      ...state,
      isLoaded,
    };
  }

  if (action.type === SET_PARTICIPANTS_EVENTS) {
    const { events } = action.payload;

    return {
      ...state,
      events,
    };
  }

  if (action.type === SET_EDUCATOR_EVENTS) {
    const { events } = action.payload;
    const educatorParseEvents = {};
    return {
      ...state,
      educatorEvents: events,
      educatorParseEvents,
    };
  }

  if (action.type === SET_CLEAN_EVENTS) {
    return {
      ...state,
      events: [],
      educatorEvents: [],
      educatorParseEvents: {},
    };
  }

  if (action.type === SET_EVENT_DETAILS) {
    const { eventDetails } = action.payload;

    return {
      ...state,
      eventDetails,
    };
  }

  if (action.type === SET_UPCOMING_EVENTS) {
    return {
      ...state,
      upcomingEvents: action.payload,
    };
  }

  if (action.type === SET_WORKING_HOURS) {
    const { workingHours } = action.payload;
    return {
      ...state,
      workingHours: {
        ...state.workingHours,
        ...workingHours,
      },
    };
  }

  if (action.type === SET_AVAILABLE_HOURS) {
    const { hours } = action.payload;

    return {
      ...state,
      workingHours: { ...state.workingHours, availableHours: hours },
    };
  }

  if (action.type === SET_UTC_DETAILS) {
    const { utcDetails } = action.payload;
    return {
      ...state,
      workingHours: {
        ...state.workingHours,
        utcLocal: utcDetails,
      },
    };
  }

  if (action.type === SET_EVENT_AS_CONFIRMED) {
    const { eventId } = action.payload;
    const { events, upcomingEvents, eventDetails } = state;
    const currentEvent = events.find((event) => event.eventId === eventId);
    currentEvent.confirmedGuest = 2;

    const inUpcomingEvent = upcomingEvents.findIndex(
      (event) => event.eventId === eventId
    );
    const clearedUpcoming = upcomingEvents;
    if (inUpcomingEvent !== -1) {
      const eventUpcoming = clearedUpcoming[inUpcomingEvent];
      eventUpcoming.resource.confirmedGuest = 2;
      clearedUpcoming[inUpcomingEvent] = eventUpcoming;
    }

    let eventDetailClone = { ...eventDetails };
    if (eventDetails.eventId === eventId) {
      eventDetailClone = {
        ...eventDetailClone,
        confirmedGuest: 2,
      };
    }

    return {
      ...state,
      events: [
        ...events.filter((event) => event.eventId !== eventId),
        currentEvent,
      ],
      upcomingEvents: [...clearedUpcoming],
      eventDetails: eventDetailClone,
    };
  }

  if (action.type === ADD_EVENT_TO_CURRENT_CALENDAR) {
    const { event } = action.payload;
    const { events } = state;

    return {
      ...state,
      events: [
        ...events.filter((_event) => _event.eventId !== event.eventId),
        event,
      ],
    };
  }

  if (action.type === SET_EVENT_AS_CANCEL) {
    const { eventId } = action.payload;
    const { events, upcomingEvents, eventDetails } = state;
    let currentEvent = events.find((event) => event.eventId === eventId);
    currentEvent = {
      ...currentEvent,
      eventStatus: {
        ...currentEvent.eventStatus,
        eventStatusId: 2,
        description: "Canceled",
      },
    };
    let eventDetailClone = { ...eventDetails };
    if (eventDetails.eventId === eventId) {
      eventDetailClone = {
        ...eventDetailClone,
        eventStatus: {
          ...currentEvent.eventStatus,
          eventStatusId: 2,
          description: "Canceled",
        },
      };
    }

    const inUpcomingEvent = upcomingEvents.filter(
      (event) => event.eventId !== eventId
    );

    return {
      ...state,
      events: [
        ...events.filter((event) => event.eventId !== eventId),
        currentEvent,
      ],
      upcomingEvents: [...inUpcomingEvent],
      eventDetails: eventDetailClone,
    };
  }

  if (action.type === SET_FAQ) {
    return {
      ...state,
      faq: [...action.payload],
    };
  }

  if (action.type === TOGGLE_EVENT_MODAL) {
    return {
      ...state,
      eventModalData: {
        openEventModal: !state.eventModalData.openEventModal,
        eventId: action.payload.eventId,
      },
    };
  }

  if (action.type === FETCHING_EVENT_DETAIL) {
    return {
      ...state,
      isFetchingEventDetail: action.payload.isFetching,
    };
  }

  if (action.type === TOGGLE_ONE_ON_ONE_MODAL) {
    let dataToChanges = {
      oneOnOneModalData: {
        open: action.payload.open,
        eventId: action.payload.eventId,
      },
    };
    if (!action.payload.open) {
      dataToChanges = {
        ...dataToChanges,
        eventDetails: { ...EVENT_DETAIL_DEFAULT_DATA },
      };
    }
    return {
      ...state,
      ...dataToChanges,
    };
  }

  return state;
};
